import jQuery from 'jquery';

(function ($) {
    $(function () {
        $(document).ready(function () {
            if ($.fn.tooltip) {
                /**
                 * Activate TB tooltip which must be done explicitly since this is an opt-in plugin.
                 */
                $('.nav-top li a').tooltip();
            } else {
                console.warn('jQuery plugin tooltip is not loaded');
            }
        });
    });
})(jQuery);

jQuery(document).ready(() => {
    (function ($) {
        if ($.fn.mmenu) {
            $("#sidemenu").mmenu({
                extensions: ['effect-slide-menu', 'pageshadow'],
                navbar: {
                    title: $('title').html()
                },
                navbars: [{
                    position: 'top'
                }, {
                    position: 'bottom',
                    height: 2,
                    content: ['<div id="mobile-footer"></div>']
                }]
            }, {
                classNames: {
                    selected: 'current'
                }
            });
        } else {
            console.warn('jQuery plugin mmenu is not loaded');
        }

        $('#mobile-footer').html($('#nav-mobile-footer').html());

        if ($.fn.carousel) {
            /* Bootstrap Carousel im hero */
            $('#startslider').carousel();
        } else {
            console.warn('jQuery plugin carousel is not loaded');
        }

        // call conversion tracking (SAB-402)
        (function (a, e, c, f, g, h, b, d) {
            var k =
                {ak: "1040506219", cl: "bkdwCNfVtWgQ67qT8AM", autoreplace: "49 (0) 2162 - 898-0"}
            ;a[c] = a[c] || function () {
                (a[c].q = a[c].q || []).push(arguments)
            }
            ;a[g] || (a[g] = k.ak);
            b = e.createElement(h);
            b.async = 1;
            b.src = "//www.gstatic.com/wcm/loader.js";
            d = e.getElementsByTagName(h)[0];
            d.parentNode.insertBefore(b, d);
            a[f] = function (b, d, e) {
                a[c](2, b, k, d, null, new Date, e)
            }
            ;a[f]()
        })(window, document, "_googWcmImpl", "_googWcmGet", "_googWcmAk", "script");

        const event = new CustomEvent('sab2019:initialized');
        document.dispatchEvent(event);
    })(jQuery)
});
